import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { isTestEnv } from "../globals";
import { useUser } from "../contexts/UserContext";
import { loginRequest } from "../authConfig";
import NotFoundPage from "../pages/ErrorPage";
import { Box, CircularProgress } from "@mui/material";

const ProtectedRoute = ({ children, requiredPermission }) => {
  isTestEnv && console.log("ProtectedRoute");

  const { instance } = useMsal();
  const { user } = useUser();
  const [isValidating, setIsValidating] = useState(true);
  const [hasValidToken, setHasValidToken] = useState(false);

  const activeAccount = instance.getActiveAccount();
  isTestEnv && console.log("activeAccount", activeAccount);
  isTestEnv && console.log("user.accessRights", user);

  useEffect(() => {
    const validateToken = async () => {
      if (!activeAccount) {
        setIsValidating(false);
        return;
      }

      try {
        await instance.initialize();
        
        try {
          await instance.acquireTokenSilent({
            ...loginRequest,
            account: activeAccount,
          });
          setHasValidToken(true);
        } catch (silentError) {
          if (silentError instanceof InteractionRequiredAuthError) {
            isTestEnv && console.log("Token expired, redirecting to login");
            await instance.acquireTokenRedirect({
              ...loginRequest,
              account: activeAccount,
            });
            return;
          }
          throw silentError;
        }
      } catch (error) {
        console.error("Token validation error:", error);
        setHasValidToken(false);
      } finally {
        setIsValidating(false);
      }
    };

    validateToken();
  }, [activeAccount, instance]);

  if (isValidating) {
    return (
      <Box 
        display="flex" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="200px"
      >
        <CircularProgress size={40} />
      </Box>
    );
  }

  if (!hasValidToken || !activeAccount) {
    return <NotFoundPage />;
  }

  if (user.accessRights !== undefined && 
      (!user.accessRights.admin && !user.accessRights?.[requiredPermission])) {
    return <NotFoundPage />;
  }

  return children;
};

export default ProtectedRoute;